import React, { useEffect, useState, useRef } from "react";
import {
  Tooltip,
  makeStyles,
  Avatar,
  TableCell,
  TableRow,
  TableCellLayout,
  PopoverTrigger,
  Popover,
  PopoverSurface,
} from "@fluentui/react-components";
import { useHistory } from "react-router-dom";
import useNavigation from "../../../../../utils/useNavigation";
import {
  FlagIcon,
  MeatBallsMenuIcon,
  PendingDeleteIcon,
  PlusIcon,
} from "../../../../../modules/default-svg";
import HoverCard from "../../../../hoverCard/HoverCard";
import {
  getAccountCurrency,
  displayDecimalFormatted,
} from "../../../../../utils/systemSettings";
import CustomInput from "../../../input/customInput/CustomInput";
import CustomSelect from "../../../select/CustomSelect";
import userService from "../../../../../store/services/user.service";
import { apiCall } from "../../../../../store/services/service";
import portfolioService from "../../../../../store/services/portfolio.service";
import {
  createProgramsRequest,
  updateProgramsRequest,
} from "../../../../../store/actions/programs.actions";
import { useDispatch } from "react-redux";
import clientService from "../../../../../store/services/clients.service";
import { generalActions } from "../../../../../store/actions";
import { URL_SEARCH_CLIENT_PORTFOLIO } from "../../../../../store/services/URL";

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const ProgramRow = (props) => {
  const {
    parentType,
    sortingCriteria,
    data,
    handleModal,
    menu,
    sortProgramsRequest,
    clientId,
    portfolioId,
    updateFlag,
    columnConfig,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [flagged, setFlagged] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState({});
  const [resources, setResources] = useState([]);
  const [ownerId, setOwnerId] = useState("");
  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const [setting] = useState(settings);
  const history = useHistory();
  const { navigateTo } = useNavigation();
  const popoverRef = useRef(null);
  const programInputRef = useRef(null);
  const clientInputRef = useRef(null);
  const portfolioInputRef = useRef(null);
  const programManagerInputRef = useRef(null);
  const budgetInputRef = useRef(null);
  const statusInputRef = useRef(null);
  const dispatch = useDispatch();

  const [clients, setClients] = useState([]);
  const [isEditRecord, setIsEditRecord] = useState(null);
  const [formErrors, setFormErrors] = useState({
    name: "",
  });

  const handleBlur = () => {
    let data = { ...isEditRecord.name };
    if (data?.owner) {
      data.ownerId = data.owner.id;
    } else {
      data.ownerId = null;
    }
    if (data?.client) {
      data.clientId = data.client.id;
    } else {
      data.clientId = null;
    }
    if (data.portfolio) {
      data.portfolioId = data.portfolio.id;
    } else {
      data.portfolioId = null;
    }
    const dat = {};
    dat.parent = parentType;
    if (parentType === "Client") {
      dat.parentId = clientId;
      dat.parent = "Client";
      data.clientId = clientId;
    }
    if (parentType === "Portfolio") {
      dat.parentId = portfolioId;
      dat.parent = "Portfolio";
      data.portfolioId = portfolioId;
    }
    if (data.name && data.clientId) {
      if (data.id) {
        dispatch(
          updateProgramsRequest({
            id: sortedData[isEditRecord.index].id,
            ...dat,
            payload: data,
          })
        );
      } else {
        dispatch(createProgramsRequest({ payload: data, ...dat }));
      }
      setIsEditRecord(null);
    } else {
      let errors = {};
      if (!data.name) {
        errors["name"] = "Name is a required Field";

        dispatch(
          generalActions.showToast({
            title: "name is a required field",
            type: "error",
          })
        );
      } else if (!data.client) {
        errors["client"] = "Client is a required Field";

        dispatch(
          generalActions.showToast({
            title: "Client is a required field",
            type: "error",
          })
        );
      }
      setFormErrors(errors);
    }
  };

  const handleEditable = (event) => {
    if (event.key === "Escape") {
      setIsEditRecord(null);
    } else if (event.key === "Enter") {
      if (isEditRecord) {
        handleBlur();
      }
    }
  };

  useEffect(() => {
    if (sortingCriteria.column !== null) {
      if (parentType === "Client")
        sortProgramsRequest({
          id: clientId,
          parent: parentType,
          page: 1,
          size: 10,
          orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
        });
      if (parentType === "Program")
        sortProgramsRequest({
          parent: parentType,
          page: 1,
          size: 10,
          orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
        });
      if (parentType === "Portfolio")
        sortProgramsRequest({
          id: portfolioId,
          parent: parentType,
          page: 1,
          size: 10,
          orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
        });
    }
  }, [sortingCriteria]);

  useEffect(() => {
    if (typeof data != "string") {
      data
        .filter((d) => d.isFlagged)
        .map((f) => {
          if (!flagged.includes(f.id)) {
            setFlagged((prevItems) => [...prevItems, f.id]);
          }
        });
      const tempDate = [...data];
      tempDate.push({
        name: "",
        client: null,
        portfolio: null,
        owner: null,
        status: "",
        budget: 0,
        startDate: "",
        endDate: "",
        stakeholderList: "",
        objectives: "",
      });
      setSortedData(tempDate);
    }
  }, [data]);

  const handleRedirectProgram = (item) => {
    // Use navigation hook instead of localStorage
    navigateTo("Programs", item.id, item.name);
  };

  const handleClientRedirect = (item) => {
    if (parentType !== "Client") {
      // Use navigation hook for direct navigation to client
      navigateTo("Clients", item.client.id, item.client.name);
    } else {
      // Already in client context, just navigate
      history.push(`/clients/${item.client.id}/overview`);
    }
  };

  const handleRedirectPortfolio = (item) => {
    if (item.portfolio) {
      if (parentType !== "Portfolio") {
        // Use navigation hook for direct navigation to portfolio
        navigateTo(
          "Portfolios",
          item.portfolio.id,
          item.portfolio.name
        );
      } else {
        // Already in portfolio context, just navigate
        history.push(`/portfolio/${item.portfolio.id}/overview`);
      }
    }
  };

  useEffect(() => {
    if (menu.props.closePopover) {
      setPopoverOpen(null);
    }
  }, [menu.props.closePopover]);

  const handlePopoverOpen = (rowId) => {
    setPopoverOpen(rowId);
  };

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      event.target?.innerText !== "Edit" &&
      event.target?.innerText !== "Delete" &&
      event.target?.innerText !== "Remind me" &&
      event?.target?.tagName !== "svg"
    ) {
      if (popoverOpen) {
        handlePopoverOpen(null);
      }
    }
    if (
      isEditRecord &&
      event.target.localName !== "input" &&
      event.target.localName !== "div" &&
      event.target.className && // Ensure className exists
      typeof event.target.className === "string" && // Ensure className is a string
      !event.target.className.includes("fui-Dropdown__button")
    ) {
      handleBlur();
    } else if (isEditRecord && event.target.placeholder === "Search") {
      handleBlur();
    }
  };

  const handleScroll = (e) => {
    handlePopoverOpen(null);
  };

  const searchPortfolioHandler = (value) => {
    if (value === "") {
      setPortfolioOptions([]);
      return;
    }
    const payload = { id: isEditRecord?.name?.client?.id, searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    if (isEditRecord?.name?.client)
      queryParam = `?clientId=${payload.id}&searchTerm=${payload.searchText}`;
    apiCall
      .get({
        url: `${URL_SEARCH_CLIENT_PORTFOLIO}${queryParam}`,
        isAuthToken: true,
      })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPortfolioOptions(transformedArray);
      })
      .catch(() => {
        setPortfolioOptions([]);
      });
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("wheel", handleScroll);
    document.addEventListener("keydown", handleEditable);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("wheel", handleScroll);
      document.removeEventListener("keydown", handleEditable);
    };
  }, [isEditRecord, popoverOpen]);

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////

  const addFlag = (id) => {
    setFlagged((prevItems) => [...prevItems, id]);
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: true,
        },
      ],
    });
  };

  const removeFlag = (id) => {
    setFlagged((prevItems) => prevItems.filter((item) => item !== id));
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: false,
        },
      ],
    });
  };

  useEffect(() => {
    const sortedArray = data;
    const tempDate = [...sortedArray];
    tempDate.push({
      name: "",
      client: null,
      portfolio: null,
      owner: null,
      status: "",
      budget: 0,
      startDate: "",
      endDate: "",
      stakeholderList: "",
      objectives: "",
    });
    setSortedData(tempDate);
  }, [flagged]);

  const sortDataByFlagged = (dataArray, flaggedArray) => {
    const flaggedItems = [];
    const remainingItems = [];

    dataArray.forEach((item) => {
      if (flaggedArray.includes(item.id)) {
        flaggedItems.push(item);
      } else {
        remainingItems.push(item);
      }
    });

    flaggedItems.sort((a, b) => {
      return flaggedArray.indexOf(a.id) - flaggedArray.indexOf(b.id);
    });

    return [...flaggedItems, ...remainingItems];
  };

  const handleInputChange = (value, type) => {
    let error = { ...formErrors };
    const data = JSON.parse(JSON.stringify(isEditRecord));
    if (type === "name") {
      data.name.name = value;
      setIsEditRecord(data);
    } else if (type === "portfolio") {
      error["portfolio"] = ``;
      setFormErrors(error);
      if (value) {
        if (!data?.name?.portfolio) {
          data.name.portfolio = {};
        }
        data.name.portfolio.name = value.label;
        data.name.portfolio.id = value.value;
      } else {
        data.name.portfolio = null;
      }
      setIsEditRecord(data);
    } else if (type === "manager") {
      if (value) {
        if (!data?.name?.owner) {
          data.name.owner = {};
        }
        data.name.owner.name = value.label;
        data.name.owner.id = value.value;
      } else {
        data.name.owner = null;
      }
      setIsEditRecord(data);
    } else if (type === "client") {
      error["client"] = ``;
      setFormErrors(error);
      if (value) {
        if (!data?.name?.client) {
          data.name.client = {};
        }
        data.name.client.name = value.label;
        data.name.client.id = value.value;
      } else {
        data.name.client = null;
      }
      data.name.portfolio = null;
      setIsEditRecord(data);
    } else if (type === "status") {
      data.name.status = value;
      setIsEditRecord(data);
    } else if (type === "budget") {
      data.name.budget = value;
      setIsEditRecord(data);
    }
  };

  const searchHandler = (value) => {
    if (value === "") {
      setResources([]);
      return;
    }
    userService
      .searchUserDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setResources(transformedArray);
      })
      .catch(() => {
        setResources([]);
      });
  };

  const searchClientHandler = (value) => {
    if (value === "") {
      setClients([]);
      return;
    }
    clientService
      .searchClientsRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClients(transformedArray);
      })
      .catch(() => {
        setClients([]);
      });
  };

  const handleIsEdiRecord = (index, type) => {
    if (index === data.length && type !== "name") {
      sortedData[index] = {
        ...isEditRecord?.name,
      };
    }
    if (isEditRecord && isEditRecord.index === index) {
      focusField(type);
      return;
    }
    setIsEditRecord({ index: index, name: sortedData[index] });
    setTimeout(() => {
      focusField(type);
    }, 0);
  };

  const focusField = (type) => {
    switch (type) {
      case "name":
        programInputRef.current?.focus();
        break;
      case "client":
        clientInputRef.current?.focus();
        break;
      case "portfolio":
        portfolioInputRef.current?.focus();
        break;
      case "budget":
        budgetInputRef.current?.focus();
        break;
      case "status":
        statusInputRef.current?.focus();
        break;
      case "manager":
        programManagerInputRef.current?.focus();
        break;
      default:
        break;
    }
  };

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////
  const sortedColumnConfig = [...columnConfig].sort(
    (a, b) => a.order - b.order
  );

  const renderTableCell = (item, index, column) => {
    const isEditing = isEditRecord && isEditRecord.index === index;

    switch (column.label) {
      case "Program":
        return (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <div className="d-flex justify-content-between inputWidth">
              <div className="d-flex align-items-center inputWidth">
                {item?.id && (
                  <Tooltip
                    positioning="before"
                    content={{
                      children: flagged.includes(item.id) ? "Unflag" : "Flag",
                      className: styles.tooltip,
                    }}
                    relationship="label"
                    withArrow
                  >
                    <span
                      className={`flag ${
                        flagged.includes(item.id) ? "flagActive" : ""
                      }`}
                      onClick={() =>
                        flagged.includes(item.id)
                          ? removeFlag(item.id)
                          : addFlag(item.id)
                      }
                    >
                      <FlagIcon />
                    </span>
                  </Tooltip>
                )}
                {isEditing ? (
                  <CustomInput
                    inputwd="inputWidth me-3"
                    icon={false}
                    placeholder="Add program name"
                    value={isEditRecord.name.name}
                    type="text"
                    handleChange={(value) => handleInputChange(value, "name")}
                    ref={programInputRef}
                    errorMessage={formErrors.name}
                    displayErrorMessage={false}
                  />
                ) : item?.id ? (
                  <span
                    className="d-flex w-full text-truncate"
                    onClick={() => handleRedirectProgram(item)}
                  >
                    {item.isPendingDelete && (
                      <div className="mr-1">
                        <PendingDeleteIcon />
                      </div>
                    )}
                    {item.name}
                  </span>
                ) : (
                  <div
                    className="d-flex _add_btn"
                    onClick={() =>
                      handleIsEdiRecord(sortedData.length - 1, "name")
                    }
                  >
                    <PlusIcon />
                    Add
                  </div>
                )}
              </div>
              {item?.id && (
                <div className="flag">
                  <Popover
                    {...props}
                    open={popoverOpen === item.id}
                    onOpenChange={(isOpen) =>
                      isOpen && handlePopoverOpen(item.id)
                    }
                    positioning="below-start"
                  >
                    <PopoverTrigger disableButtonEnhancement>
                      <TableCellLayout
                        media={<MeatBallsMenuIcon />}
                        onClick={() => handleModal(item)}
                      />
                    </PopoverTrigger>
                    <PopoverSurface
                      tabIndex={-1}
                      className="listingPopoverWrapper"
                    >
                      {menu}
                    </PopoverSurface>
                  </Popover>
                </div>
              )}
            </div>
          </TableCell>
        );
      case "Client":
        return isEditing ? (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <CustomSelect
              SelectText="client"
              searchText={searchClientHandler}
              options={clients}
              defaultVal={
                isEditRecord.name.client
                  ? {
                      label: isEditRecord.name.client.name,
                      value: isEditRecord.name.client.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "client")}
              ref={clientInputRef}
              CustomClass="ModalAvatarSearch"
              errorMessage={formErrors.client}
              displayErrorMessage={false}
            />
          </TableCell>
        ) : item.client ? (
          <TableCell
            onClick={() => handleIsEdiRecord(index, "client")}
            className={isEditing ? "" : "hoverCell"}
          >
            <span onClick={() => handleClientRedirect(item)}>
              {item.client?.name}
            </span>
          </TableCell>
        ) : (
          <TableCell onClick={() => handleIsEdiRecord(index, "client")} />
        );
      case "Portfolio":
        return (
          <TableCell
            onClick={() => handleIsEdiRecord(index, "portfolio")}
            className={isEditing ? "" : "hoverCell"}
          >
            {isEditing ? (
              <CustomSelect
                CustomClass="ModalAvatarSearch"
                persona={true}
                searchText={searchPortfolioHandler}
                SelectText="portfolio"
                options={portfolioOptions}
                defaultVal={
                  isEditRecord.name.portfolio?.name
                    ? {
                        label: isEditRecord.name.portfolio.name,
                        value: isEditRecord.name.portfolio.id,
                      }
                    : null
                }
                onChange={(e) => handleInputChange(e, "portfolio")}
                ref={portfolioInputRef}
              />
            ) : item.portfolio ? (
              <span
                className="text-truncate"
                onClick={() =>
                  item?.portfolio?.name && handleRedirectPortfolio(item)
                }
              >
                {item.portfolio.name}
              </span>
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Program Manager":
        return isEditing ? (
          <TableCell>
            <CustomSelect
              SelectText="manager"
              searchText={searchHandler}
              options={resources}
              defaultVal={
                isEditRecord.name.owner?.name
                  ? {
                      label: isEditRecord.name.owner.name,
                      value: isEditRecord.name.owner.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "manager")}
              creatable={true}
              setCreated={setOwnerId}
              CustomClass="ModalAvatarSearch"
              handleInputChange={handleInputChange}
              ref={programManagerInputRef}
            />
          </TableCell>
        ) : (
          <TableCell
            role="gridcell"
            onClick={() => handleIsEdiRecord(index, "manager")}
          >
            {item.owner ? (
              <TableCellLayout
                media={
                  <HoverCard
                    HoverCardTrigger={
                      <Avatar
                        color="colorful"
                        name={item.owner.name}
                        image={{ src: item.owner.image }}
                      />
                    }
                    AvatarId={item.owner?.id}
                    AvatarName={item.owner?.name}
                    AvatarImage={item.owner?.image}
                    AvatarDesignation={item.owner?.title}
                    AvatarEmail={item.owner?.email}
                    AvatarPhone={item.owner?.phoneNumber}
                    AvatarIsExternal={item.owner?.isExternal}
                  />
                }
              >
                {item.owner.name}
              </TableCellLayout>
            ) : (
              <TableCell />
            )}
          </TableCell>
        );
      case "Status":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "status")}>
            {isEditing ? (
              <CustomInput
                inputwd="inputWidth me-3"
                icon={false}
                placeholder="Add Status"
                value={isEditRecord.name.status}
                type="text"
                handleChange={(value) => handleInputChange(value, "status")}
                ref={statusInputRef}
              />
            ) : (
              item.status
            )}
          </TableCell>
        );
      case "Budget":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "budget")}>
            {isEditing ? (
              <CustomInput
                inputwd="inputWidth me-3"
                icon={false}
                placeholder="0"
                type="number"
                currency={true}
                inline={true}
                value={isEditRecord.name.budget}
                handleChange={(value) => handleInputChange(value, "budget")}
                ref={budgetInputRef}
              />
            ) : item?.id ? (
              `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                setting,
                item.budget
              )}`
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Actual":
        return (
          <TableCell>
            {item.id ? getAccountCurrency(setting) : ""}
            {item.id ? displayDecimalFormatted(setting, item.actual) : ""}
          </TableCell>
        );
      case "Accural":
        return (
          <TableCell>
            {item.id ? getAccountCurrency(setting) : ""}
            {item.id ? displayDecimalFormatted(setting, item.accural) : ""}
          </TableCell>
        );
      case "ETC":
        return (
          <TableCell>
            {item.id ? getAccountCurrency(setting) : ""}
            {item.id ? displayDecimalFormatted(setting, item.etc) : ""}
          </TableCell>
        );
      case "BAC":
        return (
          <TableCell>
            {item.id ? getAccountCurrency(setting) : ""}
            {item.id ? displayDecimalFormatted(setting, item.bac) : ""}
          </TableCell>
        );
      default:
        return null;
    }
  };

  const styles = useStyles();
  return sortedData.map((item, index) => (
    <TableRow key={item.id || index} className="ProjectHover" ref={popoverRef}>
      {sortedColumnConfig
        .filter((col) => col.isVisible)
        .filter((col) => parentType !== "Client" || col.label !== "Client")
        .filter(
          (col) => parentType !== "Portfolio" || col.label !== "Portfolio"
        )
        .map((col) => (
          <TableCell key={col.label}>
            {renderTableCell(item, index, col)}
          </TableCell>
        ))}
    </TableRow>
  ));
};

export default ProgramRow;
